/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_From_Split_LabelInputs */

const en_ui_studio_marker_from_split_label = /** @type {(inputs: Ui_Studio_Marker_From_Split_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance from last split`)
};

const de_ui_studio_marker_from_split_label = /** @type {(inputs: Ui_Studio_Marker_From_Split_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abstand zum letzten Teiler`)
};

/**
* | output |
* | --- |
* | "Distance from last split" |
*
* @param {Ui_Studio_Marker_From_Split_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_from_split_label = /** @type {((inputs?: Ui_Studio_Marker_From_Split_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_From_Split_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_from_split_label(inputs)
	return de_ui_studio_marker_from_split_label(inputs)
});